// Translations for the Card Template Designer page
// (frontend/src/pages/CardTemplates/CardTemplateDesigner.js)
const cardTemplateDesignerDict = [
  { en: "Edit Card Template", sw: "Hariri Kiolezo cha Kadi" },
  { en: "Create Card Template", sw: "Unda Kiolezo cha Kadi" },
  { en: "Cancel", sw: "Ghairi" },
  { en: "Saving...", sw: "Inahifadhi..." },
  { en: "Save Template", sw: "Hifadhi Kiolezo" },
  { en: "Template Details", sw: "Maelezo ya Kiolezo" },
  { en: "Template Name *", sw: "Jina la Kiolezo *" },
  { en: "e.g., Standard Card Template", sw: "mfano, Kiolezo cha Kadi ya Kawaida" },
  { en: "Description", sw: "Maelezo" },
  { en: "Template description", sw: "Maelezo ya kiolezo" },
  { en: "Card Type", sw: "Aina ya Kadi" },
  { en: "All Cards", sw: "Kadi Zote" },
  { en: "Standard Only", sw: "Kawaida Pekee" },
  { en: "Premium Only", sw: "Premium Pekee" },
  { en: "Background Image", sw: "Picha ya Nyuma" },
  { en: "Image uploaded", sw: "Picha imepakiwa" },
  { en: "Card Side", sw: "Upande wa Kadi" },
  { en: "Front", sw: "Mbele" },
  { en: "Back", sw: "Nyuma" },
  { en: "Add Elements", sw: "Ongeza Vipengele" },
  { en: "Element Properties", sw: "Mipangilio ya Kipengele" },
  { en: "Label:", sw: "Lebo:" },
  { en: "X Position", sw: "Mahali X" },
  { en: "Y Position", sw: "Mahali Y" },
  { en: "Font Size", sw: "Ukubwa wa Fonti" },
  { en: "Font Weight", sw: "Uzito wa Fonti" },
  { en: "Normal", sw: "Kawaida" },
  { en: "Bold", sw: "Nzito" },
  { en: "Color", sw: "Rangi" },
  { en: "Width (pixels)", sw: "Upana (pikseli)" },
  { en: "Height (pixels)", sw: "Urefu (pikseli)" },
  { en: "Photo Sizes:", sw: "Ukubwa wa Picha:" },
  { en: "QR Code Sizes:", sw: "Ukubwa wa QR Code:" },
  { en: "Logo Sizes:", sw: "Ukubwa wa Nembo:" },
  { en: "Small (100×130)", sw: "Ndogo (100×130)" },
  { en: "Passport (150×190)", sw: "Pasipoti (150×190)" },
  { en: "Large (180×230)", sw: "Kubwa (180×230)" },
  { en: "Small (80×80)", sw: "Ndogo (80×80)" },
  { en: "Medium (120×120)", sw: "Wastani (120×120)" },
  { en: "Large (160×160)", sw: "Kubwa (160×160)" },
  { en: "Small (60×60)", sw: "Ndogo (60×60)" },
  { en: "Medium (100×100)", sw: "Wastani (100×100)" },
  { en: "Large (140×140)", sw: "Kubwa (140×140)" },
  { en: "Delete Element", sw: "Futa Kipengele" },
  { en: "Card Side:", sw: "Upande wa Kadi:" },
  { en: "Click and drag elements to position them. Click element to edit properties.", sw: "Bonyeza na buruta vipengele ili kuvipanga. Bonyeza kipengele ili kuhariri mipangilio." },
  { en: "Please enter template name", sw: "Tafadhali weka jina la kiolezo" },
  { en: "Template updated successfully", sw: "Kiolezo kimesasishwa kwa mafanikio" },
  { en: "Template created successfully", sw: "Kiolezo kimeundwa kwa mafanikio" },
  { en: "Failed to save template", sw: "Imeshindwa kuhifadhi kiolezo" },
  { en: "Failed to load template", sw: "Imeshindwa kupakia kiolezo" },

  // Designer field-type labels (used both as button text and, translated
  // for display only, when rendering elements already placed on the canvas)
  { en: "Member Name", sw: "Jina la Mwanachama" },
  { en: "Member Number", sw: "Namba ya Mwanachama" },
  { en: "Job Title", sw: "Cheo cha Kazi" },
  { en: "Department", sw: "Idara" },
  { en: "Branch", sw: "Tawi" },
  { en: "Issue Date", sw: "Tarehe ya Kutolewa" },
  { en: "Expiry Date", sw: "Tarehe ya Mwisho" },
  { en: "Card Number", sw: "Namba ya Kadi" },
  { en: "Emergency Contact", sw: "Mawasiliano ya Dharura" },
  { en: "Emergency Phone", sw: "Simu ya Dharura" },
  { en: "Member Photo", sw: "Picha ya Mwanachama" },
  { en: "QR Code", sw: "QR Code" },
  { en: "Organization Logo", sw: "Nembo ya Shirika" },
];

export default cardTemplateDesignerDict;
